<template>
    <v-card>
        <v-toolbar dark  elevation="0" @short="true">
            <v-btn icon dark @click="$emit('input', false)">
                <v-icon>mdi-close</v-icon>
            </v-btn>
            <v-toolbar-title>
                <span v-if="isNew">Nova Publicação</span>
                <span v-else>Editar Publicação</span>
            </v-toolbar-title>
            <v-spacer />
            <v-toolbar-items>
              <v-btn dark text @click="salvarPublicacao()">Salvar</v-btn>
            </v-toolbar-items>
        </v-toolbar>
        <v-card-text>
            <v-row>
                <v-col cols="6" md="4" no-gutters>
                    <ComboGrupo :multiple="false" color="black" v-model="publicacao.grupo_id" :change="changeCombo"/>
                </v-col>
            </v-row>
            <v-row style="align-items: center;">
                <v-col cols="6" md="4" align-self="center" v-if="this.autor_id">
                    <mb-select-autor v-model="publicacao.autor_id" />
                </v-col>
                <v-col cols="6" md="8" class="mb-5" v-if="this.titulo">
                    <mb-text-field label="Título" v-model="publicacao.titulo" />
                </v-col>
            </v-row>
            <v-row no-gutters class="mb-5">
                <v-col cols="12" class="mb-8">
                    <vue-editor id="editor" v-model="publicacao.texto" v-if="this.editor" />
                </v-col>
                <v-col cols="3" v-if="this.imagem">
                    <v-file-input
                        :rules="rules"
                        v-model="imagemFile"
                        show-size
                        accept="image/png, image/jpeg"
                        placeholder="Escolher a imagem"
                        prepend-icon="mdi-camera"
                        label="Imagem"
                        color="black"
                        @change="imageToBase64"/>
                </v-col>
                <v-col cols="3" class="ml-5" v-if="this.cor_fundo">
                    <mb-color-picker label="Cor da Publicação" v-model="publicacao.cor_fundo"/>
                </v-col>
            </v-row>
            <v-row no-gutters>
                <v-col
                    cols="3">
                    <mb-data
                        label="Data da Publicação"
                        :soloInverted="false"
                        prependInnerIcon=""
                        prependIcon="event"
                        :data="publicacao.data"
                        @dataSelecionada="publicacao.data = $event"
                        />
                </v-col>
                <v-col cols="2" class="ml-5">
                    <v-checkbox label="Publicado" v-model="publicacao.publicado"/>
                </v-col>
            </v-row>
        </v-card-text>
        <v-snackbar v-model="hasSaved" :timeout="2000" absolute bottom left>Publicação atualizada</v-snackbar>
    </v-card>
</template>

<script>
    import ComboGrupo from "../../widget/ComboGrupos";
    import PublicacaoInput from '@/classes/publicacaoInput'
    import PublicacaService from '@/services/publicacaoService'
    import { VueEditor } from "vue2-editor";
    export default {
        props: {
            isNew: {
                type: Boolean
            }
        },
        data() {
            return {
                hasSaved: false,
                imagemFile: null,

                autor: false,
                titulo: false,
                imagem: false,
                cor: false,
                editor: false,

                publicacao: new PublicacaoInput()
            };
        },
        methods: {
            customFilter(item, queryText) {
                const textOne = item.name.toLowerCase();
                const textTwo = item.abbr.toLowerCase();
                const searchText = queryText.toLowerCase();

                return (
                    textOne.indexOf(searchText) > -1 || textTwo.indexOf(searchText) > -1
                );
            },
            save() {
                this.isEditing = !this.isEditing;
                this.hasSaved = true;
            },
            async salvarPublicacao() {
                try{
                    var retorno = await PublicacaService.criarPublicacao(this.publicacao)
                    if (retorno.status === 200) {
                        this.hasSaved = true
                        this.publicacao = PublicacaoInput.initGrupo(this.publicacao.grupo_id)
                    } else
                        throw new Error('Erro ao salvar');
                } catch(error) {
                     this.$toast.error("Erro ao salvar autor. " + error);
                }
            },
            clear() {
                this.autor_id = false
                this.titulo = false
                this.imagem = false
                this.cor_fundo = false
                this.editor = false
                this.publicacao = PublicacaoInput.initGrupo(this.publicacao.grupo_id)
            },
            changeCombo() {
                this.clear()
                switch (this.publicacao.grupo_id.descricao) {
                    case 'Principal':
                        this.imagem = true
                        this.editor = true
                        break;
                    case 'Nota':
                        this.titulo = true
                        this.editor = true
                        break;
                    case 'Entrevista':
                        this.autor_id = true
                        this.titulo = true
                        this.editor = true
                        break;
                    case 'Em Alta':
                        this.titulo = true
                        this.editor = true
                        break;
                    case 'Em Baixa':
                        this.titulo = true
                        this.editor = true
                        break;
                    case 'Propaganda':
                        this.cor_fundo = true
                        this.imagem = true
                        break;
                    default:
                        break;
                }
            },
            getBase64(file) {
                return new Promise((resolve, reject) => {
                    const reader = new FileReader();
                    reader.readAsDataURL(file);
                    reader.onload = () => resolve(reader.result);
                    reader.onerror = error => reject(error);
                });
            },
            imageToBase64() {
                this.getBase64(this.imagemFile).then(data => (this.publicacao.imagem = data));
            },
        },
        components: {
            ComboGrupo, VueEditor
        }
    };
</script>

<style>
    #editor {
        height: 150px;
        width: 100%;
    }
</style>
